import { Logout } from '@containers';

export default [
  {
    path: '/logout',
    component: Logout,
    exact: true,
    secret: true,
  },
];
